import apiClient from "./apiClient";

/* GET */
export const get = (url, params = {}) =>
    apiClient.get(url, { params }).then(res => res.data);

/* POST */
export const post = (url, body = {}, config={}) =>
    apiClient.post(url, body, config).then(res => res.data);

/* PUT */
export const put = (url, body = {}) =>
    apiClient.put(url, body).then(res => res.data);

/* PATCH */
export const patch = (url, body = {}) =>
    apiClient.patch(url, body).then(res => res.data);

/* DELETE */
export const remove = (url, params = {}) =>
    apiClient.delete(url, { params }).then(res => res.data);
